import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { FlowConfigurationState } from '../models/flows.model';
import * as selectors from '../selectors/flow-configuration.selectors';

@Injectable({ providedIn: 'root' })
export class FlowConfigurationFacadeService extends FacadeService {
  constructor(public override store: Store<FlowConfigurationState>) {
    super(store);
  }

  // OBSERVABLES
  contextFlowValues$ = this.storeSelect(selectors.getContextFlowValues);
  contextFlow$ = this.storeSelect(selectors.getContextFlow);
  flowEventValues$ = this.storeSelect(selectors.getFlowEventValues);
  flowEvent$ = this.storeSelect(selectors.getFlowEvent);
  renderFlowEvent$ = this.storeSelect(selectors.getRenderFlowEvent);
  renderEditFlowEvent$ = this.storeSelect(selectors.getRenderEditFlowEvent);
  displayedColumns$ = this.storeSelect(selectors.getDisplayedColumns);
  displayedColumnKeys$ = this.storeSelect(selectors.getDisplayedColumnKeys);
  flowTable$ = this.storeSelect(selectors.getFlowTable);
  flowTableExists$ = this.storeSelect(selectors.getFlowTableExists);
  dragEnabled$ = this.storeSelect(selectors.getDragEnabled);
  addFlow$ = this.storeSelect(selectors.getAddFlow);
  addFlowFiltered$ = this.storeSelect(selectors.getAddFlowFiltered);
  addFlowEmpty$ = this.storeSelect(selectors.getAddFlowEmpty);
  userSubmitted$ = this.storeSelect(selectors.getUserSubmitted);
  manageRole$ = this.storeSelect(selectors.getManageRole);
  noManageRole$ = this.storeSelect(selectors.getNoManageRole);
  disableUpdate$ = this.storeSelect(selectors.getDisableUpdate);

  // OBSERVABLE'S VALUES
  get flowEvent() {
    return this.storeSnapshot(this.flowEvent$);
  }

  get contextFlow() {
    return this.storeSnapshot(this.contextFlow$);
  }

  get flowTable() {
    return this.storeSnapshot(this.flowTable$);
  }

  get disableUpdate() {
    return this.storeSnapshot(this.disableUpdate$);
  }

  get manageRole() {
    return this.storeSnapshot(this.manageRole$);
  }

  get noManageRole() {
    return this.storeSnapshot(this.noManageRole$);
  }
}
